import { CENTRAL_ROLES } from "../constants";

export const KISTEN_ACCESS_ROLES = Object.freeze([
  CENTRAL_ROLES.KISTEN_SUPERVISOR,
  CENTRAL_ROLES.KISTEN_PLANNING,
  CENTRAL_ROLES.KISTEN_ADMIN,
]);

export function normalizeClaimRoles(claims) {
  return Array.isArray(claims?.roles)
    ? [...new Set(claims.roles.filter((role) => typeof role === "string"))]
    : [];
}

export function hasKistenAccess(roles) {
  return KISTEN_ACCESS_ROLES.some((role) => roles.includes(role));
}

export function getKistenAuthState({ loading, user, roles }) {
  if (loading) return "loading";
  if (!user) return "signed-out";
  return hasKistenAccess(roles) ? "allowed" : "denied";
}
